import React from "react";
import PropTypes from "prop-types";
import Select, { components } from "react-select";
import { ReactSelectClassName } from "components/Shared/MSelect";
import Button from "@mui/material/Button";
import Icon from "@mui/material/Icon";
import { cloneDeep } from "lodash";
import { connect } from "react-redux";

const Option = ({ ...props }) => {
    return (
        <components.Option {...props} className="react-select-option">
            <div className="md-selection-control-container">
                <input type="checkbox" id="react-select-checkbox" className="md-selection-control-input" name="simple-checkboxes[]" value="client-side-multi" aria-hidden="true" />
                <label className="md-selection-control-label md-pointer--hover md-text">
                    <div role="checkbox" aria-checked={"false"} aria-labelledby="react-select-checkbox-label" className="md-fake-btn md-pointer--hover md-fake-btn--no-outline md-selection-control-toggle md-btn md-btn--icon md-text--secondary" tabIndex="0" aria-pressed="false">
                        <div className="md-ink-container" />
                        <i className="md-icon material-icons md-text--inherit">{props.isSelected ? "check_box" : "check_box_outline_blank"}</i>
                    </div>
                    <span id="react-select-checkbox-label">{props.value}</span>
                </label>
            </div>

        </components.Option>
    );
};

const Input = ({ ...props }) => {
    return (
        <components.Input {...props} className="react-select-input" />
    );
};

const customStyles = {
    indicatorsContainer: () => ({
        display: "none",
    }),
    multiValue: () => ({
        display: "none",
    }),
    control: () => ({
        borderRadius: "0",
        borderBottom: "2px solid #C8102E",
        backgroundColor: "white",
    }),
    option: (provided, state) => ({
        ...provided,
        backgroundColor: state.isSelected ? "#eee !important" :
            state.isFocused ? "rgba(0, 0, 0, 0.12) !important" : "white !important",
    }),
    menuPortal: (base) => ({
        ...base,
        zIndex: 99999,
    }),
    menu: (base) => ({
        ...base,
        position: "relative",
        marginTop: 0,
        boxShadow: "0 4px 11px rgba(0, 0, 0, 0.1)",
        backgroundColor: "white",
        minWidth: "200px",
    }),
};

class MultiSelectFilter extends React.Component {
    constructor(props) {
        super(props);
        this.getOptions = this.getOptions.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.getSelected = this.getSelected.bind(this);
        this.updateRows = this.updateRows.bind(this);
        this.toggle = this.toggle.bind(this);
        this.onBlur = this.onBlur.bind(this);
        this.getButtonText = this.getButtonText.bind(this);
        this.removeSelectAll = this.removeSelectAll.bind(this);
        this.checkSelectAllRemoved = this.checkSelectAllRemoved.bind(this);

        let defaultSelected;
        if (this.props.defaultValue) {
            defaultSelected = this.props.defaultValue.map(v => ({ value: v, label: v }));
        } else {
            defaultSelected = props.isValidGrid ? this.getSelected(this.props.clientSideFilters) : [];
        }

        this.state = {
            options: this.getOptions(),
            rawValue: "",
            selected: defaultSelected,
            display: false,
            buttonText: this.getButtonText(defaultSelected),
            selectAllMarked: this.getSelected(this.props.clientSideFilters).find(t => t === "Select All") ? true : false,
        };
    }

    componentDidMount() {
        this._isMounted = true;
        if (this.props.isValidGrid) {
            this.updateRows(this.props.clientSideFilters);
        }
    }

    componentDidUpdate(prevProps) {
        if (this.state.display) {
            let currentMenu = document.querySelector(`.${this.props.column.key} .display-react-select-menu .react-select-input input`);
            currentMenu.focus();

            let inputDivs = document.querySelectorAll(".react-select-input input");
            inputDivs.forEach(function (inputDiv) {
                inputDiv.style.minWidth = "100px";
                inputDiv.placeholder = "Search";
            });
        }

        if (this.props.clearFilters !== prevProps.clearFilters) {
            this.handleChange([]);
        }
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    UNSAFE_componentWillReceiveProps(newProps) {
        this.setState({ options: this.getOptions(newProps) });
    }

    checkSelectAllRemoved(values) {
        if ((values.length === this.state.options.length - 1)) {
            if (!values.find(x => x.label === "Select All") && this.state.selectAllMarked) {
                return true;
            }
        }
        return false;
    }

    removeSelectAll(values) {
        let newValues = cloneDeep(values);
        let selectAllObj = newValues.find(value => value.label === "Select All");
        let index = newValues.indexOf(selectAllObj);
        if (index > -1) newValues.splice(index, 1);
        return newValues;
    }

    getButtonText(selected) {
        if (this.props.hideLabel) {
            return "";
        }
        const options = this.getOptions();
        if (selected.length === 0) {
            return "Select";
        } else if (selected.length === options.length) {
            return "All Selected";
        } else {
            return `${selected.length} selected`;
        }
    }

    getOptions(newProps) {
        let props = newProps || this.props;
        let options = props.getValidFilterValues(props.column.key);
        options = options.map(o => {
            if (typeof o === "string") {
                return { value: o, label: o };
            }
            return o;
        });
        if (this.props.isValidGrid) {
            let selectedArray = this.getSelected(this.props.clientSideFilters);
            let concatOptions = [];
            for (let selectedItem in selectedArray) {
                if (!options.find(x => x.label === selectedArray[selectedItem].label) && selectedArray[selectedItem].label !== "Select All") concatOptions.push(selectedArray[selectedItem]);
            }

            // to concat options that go away when selecting a server side filter - returned options for client side will be less but with filtersaving, the filter will still be applied but not visible.
            options = options.concat(concatOptions);
            options.sort(function (a, b) {
                if (a.type === "span") {
                    //Locked Cell Case
                    return a.props.children.localeCompare(b.label);
                }
                return a.label.localeCompare(b.label);
            });
        }
        options.unshift({ value: "Select All", label: "Select All" });
        return options;
    }

    columnValueContainsSearchTerms(columnValue, filterTermValue) {
        if (columnValue !== undefined && filterTermValue !== undefined) {
            let strColumnValue = columnValue.toString();
            let strFilterTermValue = filterTermValue.toString();
            let checkValueIndex = strColumnValue.trim().toLowerCase().indexOf(strFilterTermValue.trim().toLowerCase());
            return checkValueIndex !== -1 && (checkValueIndex !== 0 || strColumnValue === strFilterTermValue);
        }
        return false;
    }

    handleChange(value) {
        let selected;
        let selectAll = false;
        // if in this change, select all is removed then set selected to empty
        if (this.checkSelectAllRemoved(value)) {
            selected = [];
            selectAll = false;
        } else {
            // check if in this change, select all is clicked or if select all is selected already and other option is clicked
            if (value.find(title => title.label === "Select All")) selectAll = true;
            // if other option is selected, then unselect select all along
            if (this.state.selectAllMarked) {
                selected = this.removeSelectAll(value);
                selectAll = false;
            } else {
                // if select all is clicked this time, set selected to all the options available
                if (selectAll) {
                    selected = this.state.options;
                } else {
                    selected = value;
                }
            }
        }
        this.setState({ selected: selected, selectAllMarked: selectAll, buttonText: this.getButtonText(selected) });
        let valueObj = [];
        if (this.props.column.key === "daysInVS") {
            valueObj = selected.map(x => this.state.map[x]);
        } else {
            valueObj = selected;
        }
        this.props.onChange({ filterTerm: valueObj, column: this.props.column, rawValue: valueObj, filterValues: this.props.filterValues, mapSelected: value });
    }

    getSelected(filter) {
        if (this.props.column.key === "daysInVS") {
            if (filter[this.props.column.key]) {
                return filter[this.props.column.key].mapSelected;
            } else {
                return [];
            }
        }
        let columnToFilter = this.props.column.key;
        let selected = filter[columnToFilter] ? filter[columnToFilter].filterTerm : [];
        if (selected.find(t => t === "Select All")) {
            return this.state.options;
        }
        return selected;
    }

    updateRows(filter) {
        let columnToFilter = this.props.column.key;
        let filterTermArray = filter[columnToFilter] ? filter[columnToFilter].filterTerm : [];

        this.props.onChange({ filterTerm: filterTermArray, column: this.props.column, rawValue: filterTermArray, filterValues: this.props.filterValues });
    }

    toggle() {
        let toggledState = !this.state.display;
        this.setState({ display: toggledState });
    }

    onBlur() {
        setTimeout(() => {
            if (this._isMounted) {
                this.setState({ display: false });
            }
        }, 200);
    }

    render() {
        // Use icon-only mode when hideLabel is true or text is "Select" (default state)
        const showIconOnly = this.props.hideLabel || this.state.buttonText === "Select";
        
        return (
            <div className={this.props.column.key}>
                <div className={`client-multi-select${this.state.display ? ' dropdown-open' : ''}`}>
                    <Button id="menu-button-3-toggle" style={{ color: "lightgray", textTransform: "none", fontSize: "14px", fontWeight: 400 }} onClick={this.toggle} endIcon={<Icon>arrow_drop_down</Icon>}>{showIconOnly ? '' : this.state.buttonText}</Button>
                    <div className={this.state.display ? "display-react-select-menu" : "display-react-select-menu-none"} onBlur={this.onBlur}>
                        <Select
                            className={ReactSelectClassName}
                            classNamePrefix="react-select"
                            closeMenuOnSelect={false}
                            isMulti
                            components={{ Option, Input }}
                            options={this.state.options}
                            hideSelectedOptions={false}
                            backspaceRemovesValue={false}
                            onChange={this.handleChange}
                            value={this.state.selected}
                            defaultValue={this.state.selected}
                            menuIsOpen={this.state.display}
                            placeholder=""
                            isClearable={false}
                            styles={customStyles}
                            menuPortalTarget={document.body}
                            menuPosition="fixed"
                        />
                    </div>
                </div>
            </div>
        );
    }
}

Option.propTypes = {
    isSelected: PropTypes.bool.isRequired,
    value: PropTypes.string.isRequired
};

MultiSelectFilter.propTypes = {
    onChange: PropTypes.func.isRequired,
    getValidFilterValues: PropTypes.func,
    multiSelection: PropTypes.bool,
    column: PropTypes.object,
    clientSideFilters: PropTypes.object.isRequired,
    defaultValue: PropTypes.array, //[{ value, label }, ...]this will override the client side filters because the client side filters are coming directly from state and that is bad
    saveClientSideFilters: PropTypes.func.isRequired,
    filterValues: PropTypes.func.isRequired,
    isValidGrid: PropTypes.bool.isRequired,
    clearFilters: PropTypes.number,
    hideLabel: PropTypes.bool,
};

const mapStateToProps = (state) => {
    return {
        clearFilters: state.filters.clearFilters
    };
};

export default connect(mapStateToProps)(MultiSelectFilter);
